import { Component, OnInit, Input, ViewChild, SimpleChanges } from '@angular/core';
import { cloneDeep } from 'lodash';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-info-order',
  templateUrl: './info-order.component.html',
  styleUrls: ['./info-order.component.css']
})
export class InfoOrderComponent implements OnInit {

  @Input()
  infosNote$: any;
  @Input()
  currSM: any;

  @Input()
  error: string|any;

  @Input()
  currPOS: any;

  filteredCountries: any;
  phoneError: any
  errorPhone: any;
  filteredCountriesClone:any;


  foods = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'},
  ];
  constructor(
    private tools: ToolsService,
    private countriesApi: CountriesService,
    private orderApi: ClientOrdersService
  ) {
    /**
     * Get errors order data
     */
    this.errorPhone = this.orderApi.getErrorPhone.subscribe((error) => {
   
        this.phoneError = error;
     
    
    });
  }

  ngOnInit() {


    //call getCountries if is_phone
    let is_phone = this.infosNote$.find((value: any) => value.is_phone == 1);
    if (is_phone) {
      this.getCountries();
    }


    // set disable
    if (this.currSM && this.currSM.disable_authentification_info_notes) {
      this.infosNote$.forEach((element: any) => {
        element.disabled = element.is_numeric === 1 && element.value ? true : false;
      });

    }

  }

  /**
    * @description On se désabonne de tous les abonnements aux observables
    */
  ngOnDestroy(): void {


    if (this.errorPhone) {
      this.errorPhone.unsubscribe();
    }
  }



  ngOnChanges(changes: SimpleChanges): void {
  
  }

  /**
  * @description update InfoNote in localstorage
  */
  updateInfoNote(value?: any) {



    //reset error
    if (value === this.error) {
      this.phoneError = null;
    }
   
    this.tools.setStor("infos_note", this.infosNote$);

    this.orderApi.setErrorPhone(null);
   
  
  }



  /**
  * @description Récupère les pays et ensuite set les données par defaut via la fonction setDefaultData()
  * @return {Void}
  */
  getCountries(): void {
   
    this.countriesApi.getCountries().subscribe(countries => {
      this.filteredCountries = countries;
        //set country default
      this.infosNote$.forEach((element: any) => {
        if (element.is_phone == 1) {
         let country=this.filteredCountries.find((value: any) => value.id == this.currPOS.country.id);
         element.country_id = country.id;
         element.flag=country.flag;
         element.country_name=country.name;
        }
        this.tools.setStor("infos_note", this.infosNote$); 
      });
    })
  }



  /**
  * @description set les elements country ()
  */

  

  setSelectedCountry(ev:any,info:any){
    info.country_id=ev.value;
     let country=this.filteredCountries.find((value: any) => value.id == info.country_id);
     info.flag=country.flag;
     info.country_name=country.name;
     this.tools.setStor("infos_note", this.infosNote$); 
     this.orderApi.setErrorPhone(null);
  }




}
